export default __webpack_public_path__ + "static/media/Nisi.6549fc52.png";